import { createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment";
import {
	addParams,
	getList,
	getParamsList,
	postAdd,
} from "../../../helpers/Helper";
import { Modal } from "antd";
import {
	RiCheckboxCircleLine,
	RiAlertLine,
	RiInformationLine,
} from "react-icons/ri";

export const getDistributorReturns = createAsyncThunk(
	"/getDistributorReturns",
	async (payload) => {
		const params = addParams(payload);
		try {
			const response = await getParamsList(
				`/returns/distributor/returns/`,
				params
			);
			if (response) {
				return response;
			} else {
				throw new Error(response);
			}
		} catch (error) {
			return error.message;
		}
	}
);
export const getDistributorReturnByID = createAsyncThunk(
	"/getDistributorReturnByID",
	async (payload) => {
		const params = addParams(payload);
		try {
			const response = await getList(
				`/returns/distributor/returns/${params.id}`
			);
			if (response) {
				return response.data;
			} else {
				throw new Error(response);
			}
		} catch (error) {
			return error.message;
		}
	}
);
